import { Route, Routes } from 'react-router-dom'

import { NetworkError, ResponseError, GenericError } from '~containers'

function Error() {
  return (
    <Routes>
      <Route index element={<GenericError />} />
      <Route path="internet" element={<NetworkError />} />
      <Route path="envio-dados" element={<ResponseError />} />
    </Routes>
  )
}

export default Error
